/**
 * 培诺3D视界，分销代理系统路由配置
 */
export default [
  {
    path: '/pennon-agent/login',
    name: 'PennonAgentLogin',
    component: () => import('@/views/pennon-agent/login.vue'),
    meta: { title: '培诺3D视界-代理客户合作平台' }
  },
  {
    path: '/pennon-agent/home',
    name: 'PennonAgentHome',
    component: () => import('@/views/pennon-agent/home.vue'),
    meta: { title: '培诺3D视界-代理客户合作平台-主页' }
  },
  {
    path: '/pennon-agent/list',
    name: 'PennonAgentList',
    component: () => import('@/views/pennon-agent/list.vue'),
    meta: { title: '培诺3D视界-代理客户合作平台-用户列表' }
  },
  {
    path: '/pennon-agent/invitation',
    name: 'PennonAgentInvitation',
    component: () => import('@/views/pennon-agent/invitation.vue'),
    meta: { title: '培诺3D视界-代理客户合作平台-邀约' }
  },
  {
    path: '/pennon-agent/register',
    name: 'PennonAgentRegister',
    component: () => import('@/views/pennon-agent/register.vue'),
    meta: { title: '培诺3D视界-邀约注册' }
  },
  {
    path: '/pennon-agent/qrcode',
    name: 'PennonAgentQrcode',
    component: () => import('@/views/pennon-agent/qrcode.vue'),
    meta: { title: '培诺3D视界-注册成功' }
  },
  {
    path: '/pennon-agent/group',
    name: 'PennonAgentGroup',
    component: () => import('@/views/pennon-agent/group.vue'),
    meta: { title: '培诺3D视界-代理客户合作平台-维护群聊' }
  },
  {
    path: '/pennon-agent/settlement',
    name: 'PennonAgentSettlement',
    component: () => import('@/views/pennon-agent/settlement.vue'),
    meta: { title: '培诺3D视界-佣金结算' }
  },
  {
    path: '/pennon-agent/sign',
    name: 'PennonAgentSign',
    component: () => import('@/views/pennon-agent/sign.vue'),
    meta: { title: '培诺3D视界-代理协议签约' }
  },
  {
    path: '/pennon-agent/settlement-detail',
    name: 'PennonAgentSettlementDetail',
    component: () => import('@/views/pennon-agent/settlementdetail.vue'),
    meta: { title: '培诺3D视界-佣金结算明细' }
  }
]
